"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./allegato"), exports);
__exportStar(require("./allegato-dto"), exports);
__exportStar(require("./cambio-sessione-tipologie-lauree-dto"), exports);
__exportStar(require("./cambio-sezione-dto"), exports);
__exportStar(require("./cambio-sezione-request-dto"), exports);
__exportStar(require("./cambio-sezione-response-dto"), exports);
__exportStar(require("./cambio-sezione-view"), exports);
__exportStar(require("./codifica-stati-dto"), exports);
__exportStar(require("./compila-nulla-osta-dto"), exports);
__exportStar(require("./compilazione-anagrafica-iscritto-dto"), exports);
__exportStar(require("./compilazione-anagrafica-oconaf-dto"), exports);
__exportStar(require("./compilazione-anagrafica-ostp-dto"), exports);
__exportStar(require("./compilazione-anagrafica-oot-dto"), exports);
__exportStar(require("./compilazione-anagrafica-stp-dto"), exports);
__exportStar(require("./compilazione-dto"), exports);
__exportStar(require("./compilazione-iscritto-dto"), exports);
__exportStar(require("./compilazione-oconaf-dto"), exports);
__exportStar(require("./compilazione-ostp-dto"), exports);
__exportStar(require("./compilazione-oot-dto"), exports);
__exportStar(require("./compilazione-stp-dto"), exports);
__exportStar(require("./compilazione-trasferimento-ordine-dto"), exports);
__exportStar(require("./composizione-societaria-dto"), exports);
__exportStar(require("./comune-dto"), exports);
__exportStar(require("./generic-attachment"), exports);
__exportStar(require("./generic-request-dto"), exports);
__exportStar(require("./iot-dto"), exports);
__exportStar(require("./iscrizione-dto"), exports);
__exportStar(require("./iscrizione-ordine-territoriale"), exports);
__exportStar(require("./iscrizione-soggetto-entity-view"), exports);
__exportStar(require("./laurea-dto"), exports);
__exportStar(require("./laurea-request-dto"), exports);
__exportStar(require("./local-date"), exports);
__exportStar(require("./local-date-time"), exports);
__exportStar(require("./msys-attachment-type"), exports);
__exportStar(require("./msys-file-output"), exports);
__exportStar(require("./paged-request-dto"), exports);
__exportStar(require("./paginated-request-dtoprepare-richiesta-request-dto"), exports);
__exportStar(require("./paginated-response-dtocambio-sezione-view"), exports);
__exportStar(require("./paginated-response-dtotrasferimento-ordine-view"), exports);
__exportStar(require("./parameter-input-dto"), exports);
__exportStar(require("./po-assicurazione"), exports);
__exportStar(require("./po-assicurazione-allegati"), exports);
__exportStar(require("./po-assicurazione-aumento-massimale"), exports);
__exportStar(require("./po-compilazione-rischio-dettaglio"), exports);
__exportStar(require("./po-compilazione-tabella-rischio"), exports);
__exportStar(require("./po-fascia-rischio-massimali"), exports);
__exportStar(require("./po-tabelle-fascia-rischio-massimali"), exports);
__exportStar(require("./po-voci-prestazione"), exports);
__exportStar(require("./prepare-richiesta-cambio-sezione-request-dto"), exports);
__exportStar(require("./prepare-richiesta-request-dto"), exports);
__exportStar(require("./provincia-dto"), exports);
__exportStar(require("./provvedimenti-disciplinari-dto"), exports);
__exportStar(require("./quota-annuale"), exports);
__exportStar(require("./quota-annuale-dto"), exports);
__exportStar(require("./recupero-iscrizione-by-id-dto"), exports);
__exportStar(require("./recupero-iscrizione-in-compilazione-dto"), exports);
__exportStar(require("./residenza-trasferimento-ordine-dto"), exports);
__exportStar(require("./response-dto"), exports);
__exportStar(require("./richiesta-integrazioni-valutazione-iscritto-dto"), exports);
__exportStar(require("./richiesta-integrazioni-valutazione-stp-dto"), exports);
__exportStar(require("./richiesta-iscrizione-iscritto-dto"), exports);
__exportStar(require("./richiesta-iscrizione-oconaf-dto"), exports);
__exportStar(require("./richiesta-iscrizione-ostp-dto"), exports);
__exportStar(require("./richiesta-iscrizione-oot-dto"), exports);
__exportStar(require("./richiesta-iscrizione-stp-dto"), exports);
__exportStar(require("./richiesta-request-dto"), exports);
__exportStar(require("./richiesta-response-dto"), exports);
__exportStar(require("./sede-legale-compilazione-iscritto-dto"), exports);
__exportStar(require("./sede-legale-compilazione-stp-dto"), exports);
__exportStar(require("./sede-legale-dto"), exports);
__exportStar(require("./sede-legale-trasferimento-ordine-dto"), exports);
__exportStar(require("./soggetto-compilazione-iscritto-dto"), exports);
__exportStar(require("./soggetto-compilazione-oconaf-dto"), exports);
__exportStar(require("./soggetto-compilazione-ostp-dto"), exports);
__exportStar(require("./soggetto-compilazione-oot-dto"), exports);
__exportStar(require("./soggetto-compilazione-stp-dto"), exports);
__exportStar(require("./soggetto-dto"), exports);
__exportStar(require("./soggetto-documento-dto"), exports);
__exportStar(require("./stato-iscritto-dto"), exports);
__exportStar(require("./stato-stp-dto"), exports);
__exportStar(require("./string-param"), exports);
__exportStar(require("./tipo-allegato"), exports);
__exportStar(require("./tipo-allegato-request-dto"), exports);
__exportStar(require("./tipo-laurea-dto"), exports);
__exportStar(require("./tipo-pagamento-request-dto"), exports);
__exportStar(require("./tipologia-abilitazione-request-dto"), exports);
__exportStar(require("./tipologia-iscrizione"), exports);
__exportStar(require("./tipologia-iscrizione-dto"), exports);
__exportStar(require("./tipologia-utente-enum"), exports);
__exportStar(require("./todo-event-dto"), exports);
__exportStar(require("./trasferimento-ordine-dto"), exports);
__exportStar(require("./trasferimento-ordine-view"), exports);
__exportStar(require("./upload-item-schema"), exports);
__exportStar(require("./valutazione-cambio-sezione-dto"), exports);
__exportStar(require("./valutazione-dto"), exports);
__exportStar(require("./valutazione-dto1"), exports);
__exportStar(require("./valutazione-iscritto-dto"), exports);
__exportStar(require("./valutazione-iscrizione-iscritto-dto"), exports);
__exportStar(require("./valutazione-iscrizione-stp-dto"), exports);
__exportStar(require("./valutazione-stp-dto"), exports);
__exportStar(require("./valutazione-trasferimento-ordine-dto"), exports);
